
import { Vue, Component } from 'vue-property-decorator'
import Pagination from '@/components/Pagination/index.vue'
import SchoolSelector from '../payment/components/school-selector.vue'
import CurrentClassSelect from '../payment/components/current-class-select.vue'
import { faceTempleteService } from '@/api/payments/faceTempleteService'
import {
  WxPhoneParentDto
} from '@/api/service-proxies'

import PagedListBase, { PagedRequestDto } from '@/lib/view-base/paged-list-base'
import { UserDto } from '@/api/service-proxies'
import moment from 'moment'
import appconst from "@/lib/appconst";

class PageWxPhoneRequest extends PagedRequestDto {
  tenantId: number
  studentName:string
  gradeNo!: number
  classNo!: number
  bangdingYY!: boolean
}

@Component({
  components: {
    Pagination,
    SchoolSelector,
    CurrentClassSelect
  },
})
export default class WxPhoneParents extends PagedListBase<
  PageWxPhoneRequest,
  WxPhoneParentDto
> {
  request = new PageWxPhoneRequest()
  selectedFaceTempletes = []
  countYes = 0;
  countNo = 0;
  private $http: any;
  isTableLoading = false;
  showVipSelector = false
  isExporting =false;
  created() {
    this.pageSize=30;
    this.getpage();
  }

  getpage() {
    this.getStatic();
    this.isTableLoading = true;
    faceTempleteService
      .getWxPhoneParent(
        this.request.tenantId,
        this.request.studentName,
        this.request.gradeNo,
        this.request.classNo,
        this.request.bangdingYY,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then((result) => {
        this.list = result.items
        this.showPaging(result)
      })
      .finally(() => {

      })
  }

  getStatic(){
    faceTempleteService
      .getWxPhoneParentStatic(
        this.request.tenantId,
        this.request.studentName,
        this.request.gradeNo,
        this.request.classNo,
        this.request.bangdingYY,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then((result) => {
        this.countYes = result.wxPhoneParentY
        this.countNo = result.wxPhoneParentN
      })
      .finally(() => {
        this.isTableLoading = false;
      })
  }

  currentClassChange(event: any) {
    this.request.gradeNo = event.gradeNo
    this.request.classNo = event.classNo
  }

  schoolChange(event: any) {
    this.request.tenantId = event.tenantId
  }

  //导出
  exportExcel() {
    this.isExporting = true;
    if(this.request.tenantId == undefined && this.request.bangdingYY == undefined){
      this.$message.warning("必须选择一个学校或者选择已绑定");
      this.isExporting = false;
      return;
    }
        this.$http
            .post(
                appconst.remoteServiceBaseUrl +
                    "sysadmin/api/ExportUnicomRegistration/ExportWxPhoneParent",
                {
                  TenantId: this.request.tenantId,
                  StudentName: this.request.studentName,
                    gradeNo: this.request.gradeNo,
                    classNo: this.request.classNo,
                    BangdingY: this.request.bangdingYY,
                },
                {
                    responseType: "arraybuffer",
                }
            )
            .then((res) => {
                let a = document.createElement("a");
                let blob = new Blob([res], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });

                a.href = URL.createObjectURL(blob);
                a.download = "微信电话绑定情况表.xlsx";
                a.click();

                URL.revokeObjectURL(a.href);
            })
            .finally(() => {
                this.isExporting = false;
            });
    }

}
